import {
  Button,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Radio,
  Select,
  Spin,
  Table,
  Typography,
} from "antd";
import "./ReusableModal.css";
import {
  ArrowRightOutlined,
  CheckOutlined,
  ExclamationCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useCallback, useEffect, useState } from "react";
import {
  buyerCampaigns,
  createInstantCampaign,
  getBuyerCampaigns,
  getCampaignsForPurchase,
  getUserSavedCampaigns,
  moveProductToCampaign,
} from "../../../store/thunks/buyer-thunks/BuyerThunks";
import { useDispatch, useSelector } from "react-redux";
import Search from "antd/es/input/Search";
import {
  getDefaultPaymentTerms,
  updateAllNegotiationTerms,
} from "../../../store/thunks/common-thunks/commonThunk";
import { formatDate } from "date-fns";
import { formatToMMDDYYYY, formatToUSCurrency } from "../../common/utils/Utils";
import FloatingInput from "../../common/float-input/FloatInput";
import dayjs from "dayjs";
const ReusableModal = ({
  record,
  type,
  isActionModal,
  setIsActionModal,
  isNegotiating,
  selectedChatProduct,
  campaignDetails,
  approveData,
  lastTermsData,
  chatGroupId,
  lastTermsMessage,
  campaignsPage = false,
  max_date,
  min_date,
  filterPayload,
}) => {
  const { Text } = Typography;
  const dispatch = useDispatch();
  const {
    buyerCampaignsList,
    savedCampaigns,
    isLoading: buyerCampaignsLoader,
    getBuyerCampaignsLoading,
    moveProductToCampaignLoading,
    instantCampaignLoading,
  } = useSelector((state) => state.buyerCampaigns);
  const { isNegotiationLoading } = useSelector(
    (state) => state?.negotiationTerms,
  );
  const isLoading =
    getBuyerCampaignsLoading ||
    moveProductToCampaignLoading ||
    isNegotiationLoading ||
    instantCampaignLoading;
  const [campaignSearch, setCampaignSearch] = useState("");
  const [debouncedCampaignSearch, setDebouncedCampaignSearch] = useState("");
  // Bulk campaign modal state
  const [bulkCampaignMode, setBulkCampaignMode] = useState("existing");
  const [bulkSelectedCampaign, setBulkSelectedCampaign] = useState(undefined);
  const [bulkNewCampaignName, setBulkNewCampaignName] = useState("");
  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const [bulkCampaignForm] = Form.useForm();
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  useEffect(() => {
    if (type !== "Move") return;
    dispatch(
      getBuyerCampaigns({
        value: "saved_campaign",
      }),
    );
  }, [type, dispatch]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedCampaignSearch(campaignSearch);
    }, 300);
    return () => clearTimeout(timer);
  }, [campaignSearch]);
  const handleCloseModal = () => {
    setCampaignSearch("");
    setDebouncedCampaignSearch("");
    if (type === "BulkCampaign") {
      setBulkCampaignMode("existing");
      setBulkSelectedCampaign(undefined);
      setBulkNewCampaignName("");
      bulkCampaignForm.setFieldsValue({
        campaign_id: undefined,
        campaign_name: undefined,
      });
      bulkCampaignForm.setFields([
        { name: "campaign_id", errors: [] },
        { name: "campaign_name", errors: [] },
      ]);
    }
    setIsActionModal(false);
  };
  const currentCampaignId = campaignsPage
    ? selectedChatProduct?.campaign_id
    : campaignDetails?.campaign_id;
  const filteredCampaigns =
    buyerCampaignsList?.filter((campaign) => {
      const campaignId = campaign?.id || campaign?._id;
      return (
        String(campaignId) !== String(currentCampaignId) &&
        campaign?.name
          ?.toLowerCase()
          .includes(debouncedCampaignSearch.toLowerCase())
      );
    }) || [];
  const handleMoveCampaign = (campaign) => {
    const payload = {
      campaign_id: campaign?.id,
      product_booking_id: campaignsPage
        ? selectedChatProduct?.productbookingid
        : campaignDetails?.originalProduct?.productbookingid,
    };
    dispatch(moveProductToCampaign(payload)).then((res) => {
      if (res?.payload.status == 1) {
        dispatch(getCampaignsForPurchase());
        if (campaignsPage) {
          dispatch(buyerCampaigns(campaign?.id));
        }
        setIsActionModal(false);
      }
    });
  };
  const accessToCampaignDrawer = useCallback(() => {
    dispatch(getUserSavedCampaigns());
  }, [dispatch]); //dependencies
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      accessToCampaignDrawer();
    }
  }, [dispatch, accessToCampaignDrawer]);

  const formatToMMMDDYYYY = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };
  const calendarData = approveData?.paymentTerms?.calendarData || [];
  const percentageData = approveData?.paymentTerms?.percentageData || [];
  const totalAmount =
    Number(approveData?.product?.originalProduct?.offerpriceperselectedDates) ||
    0;
  const paymentDetails = calendarData?.map((date, index) => {
    const percentage = Number(percentageData[index] || 0);
    return {
      payment: `Payment ${index + 1}`,
      date,
      percentage,
      amount: (totalAmount * percentage) / 100,
    };
  });
  const handleCounterOfferStatus = (
    approvalStatus,
    termsData = lastTermsData,
  ) => {
    const termsGroupId = Array.isArray(termsData)
      ? termsData?.[0]?.group_id
      : termsData?.group_id;
    const lastTermsChatGroupId = lastTermsMessage?.chat_group_id;
    const finalChatGroupId =
      chatGroupId || termsGroupId || lastTermsChatGroupId;
    const payload = {
      chat_group_id: finalChatGroupId,
      approval_status: approvalStatus,
    };
    dispatch(updateAllNegotiationTerms(payload)).then((res) => {
      if (res?.payload?.status == 1) {
        dispatch(getCampaignsForPurchase());
      }
    });
  };
  const handleStaticBulkCampaignCreate = (values) => {
    const formatDateValue = (date) =>
      date?.format ? date.format("YYYY-MM-DD") : date || "";
    const minDate = Array.isArray(min_date)
      ? parseApiDate(min_date[0])
      : parseApiDate(min_date);
    const maxDate = parseApiDate(max_date);
    const hasBookedDateFields =
      filterPayload &&
      "booked_from" in filterPayload &&
      "booked_to" in filterPayload;
    const payload = {
      ...(filterPayload || {}),
      type: bulkCampaignMode,
      ...(hasBookedDateFields
        ? {
            booked_from: minDate?.isValid()
              ? minDate.format("YYYY-MM-DD")
              : filterPayload.booked_from,
            booked_to: maxDate?.isValid()
              ? maxDate.format("YYYY-MM-DD")
              : filterPayload.booked_to,
          }
        : {
            startDate: formatDateValue(values.start_date),
            endDate: formatDateValue(values.end_date),
          }),

      ...(bulkCampaignMode === "existing"
        ? {
            campaign_id: values.campaign_id ?? bulkSelectedCampaign,
          }
        : {
            name: values.campaign_name?.trim() || bulkNewCampaignName.trim(),
          }),
    };
    dispatch(createInstantCampaign(payload)).then((res) => {
      if (res?.payload.status == 1) {
        handleCloseModal();
      }
    });
  };
  const parseApiDate = (value) => {
    if (!value) return null;
    const timestamp =
      value?.$date?.$numberLong ?? value?.$date ?? value?.$numberLong ?? value;
    const date = new Date(Number(timestamp));
    return Number.isNaN(date?.getTime()) ? null : dayjs(date);
  };
  useEffect(() => {
    const startDate = Array.isArray(min_date)
      ? parseApiDate(min_date[0])
      : parseApiDate(min_date);
    const endDate = parseApiDate(max_date);
    bulkCampaignForm.setFieldsValue({
      start_date: startDate,
      end_date: endDate,
    });
  }, [min_date, max_date, bulkCampaignForm]);
  const isCreateDisabled =
    bulkCampaignMode === "existing"
      ? bulkSelectedCampaign == null || bulkSelectedCampaign === ""
      : !bulkNewCampaignName.trim();

  const renderModalContent = () => {
    switch (type) {
      case "Move":
        return (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Text className="common-text-101828-14">
                Move to Another Campaign
              </Text>
              <span className="grey-color-text-99a1af-11">
                {" "}
                Moving:{" "}
                <span className="grey-color-text-4A5565-12 ">
                  {!campaignsPage
                    ? campaignDetails?.asset
                    : selectedChatProduct?.title || "N/A"}
                </span>
              </span>
              <Divider style={{ margin: "10px 0px" }} />
              {isNegotiating && (
                <div className="reservation-banner" style={{ padding: "15px" }}>
                  <div
                    className="review-warning"
                    style={{ alignItems: "flex-start" }}
                  >
                    <ExclamationCircleOutlined />
                    <span className="common-text-E17100-12">
                      This product is currently under negotiation. Moving it
                      will transfer the negotiation to the new campaign.
                    </span>
                  </div>
                </div>
              )}
              <Text
                className="common-product-detail-text-grey-10"
                style={{ fontWeight: "600" }}
              >
                Select destination campaign
              </Text>
              <div
                className="customer-details-of-rfp-row"
                style={{ width: "100%" }}
              >
                {buyerCampaignsList?.length > 10 && (
                  <Input
                    prefix={<SearchOutlined />}
                    placeholder="Search campaigns"
                    value={campaignSearch}
                    onChange={(e) => setCampaignSearch(e.target.value)}
                    allowClear
                    style={{ marginBottom: "10px" }}
                    className="campaign-search-list"
                  />
                )}

                {filteredCampaigns?.length > 0 ? (
                  filteredCampaigns?.map((campaign, index) => (
                    <div
                      className="campaign-container"
                      key={campaign?.id || campaign?._id || index}
                      onClick={() => {
                        handleMoveCampaign(campaign);
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        <Text
                          className="common-text-101828-14"
                          style={{
                            fontWeight: "500",
                            marginTop: "10px",
                          }}
                        >
                          {campaign?.name || "-"}
                        </Text>

                        <Text className="grey-color-text-99a1af-11">
                          {campaign?.product_count || 0} assets currently
                        </Text>
                      </div>

                      <ArrowRightOutlined />
                    </div>
                  ))
                ) : (
                  <div className="campaign-container">
                    <Text className="grey-color-text-99a1af-11">
                      No campaigns found
                    </Text>
                  </div>
                )}
              </div>
            </div>
          </>
        );
      case "approve":
        return (
          <div className="approve-offer-modal">
            <div className="approve-offer-icon">
              <CheckOutlined />
            </div>
            <Text className="common-sub-header-black-14">
              Accept Buyer's Offer?
            </Text>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Text
                className="location-grey-text-12"
                style={{ textAlign: "center" }}
              >
                You are about to accept the offer from{" "}
                <strong>{approveData?.campaign?.name}</strong>. An Insertion
                Order will be prepared.
              </Text>
            </div>
            <div className="approve-offer-details">
              <div className="approve-offer-detail-row">
                <span className="approve-offer-detail-label">Agreed price</span>
                <span className="approve-offer-detail-value approve-price">
                  {formatToUSCurrency(
                    approveData?.product?.originalProduct
                      ?.offerpriceperselectedDates,
                  )}
                </span>
              </div>
              <div className="approve-offer-detail-row">
                <span className="approve-offer-detail-label">
                  Campaign dates
                </span>
                <span className="common-text-color-black-13">
                  {formatToMMMDDYYYY(
                    approveData?.campaign?.campaign_dates?.campaign_start_date,
                  )}{" "}
                  →{" "}
                  {formatToMMMDDYYYY(
                    approveData?.campaign?.campaign_dates?.campaign_start_date,
                  )}
                </span>
              </div>
              <div
                className="approve-offer-detail-row"
                style={{ marginTop: "5px" }}
              >
                <div style={{ width: "100%" }}>
                  {paymentDetails.length > 0 ? (
                    <Table
                      className="approve-offer-table"
                      columns={[
                        {
                          title: "Date",
                          dataIndex: "date",
                          key: "date",
                          render: (date) => formatToMMMDDYYYY(date),
                        },
                        {
                          title: "Amount",
                          dataIndex: "amount",
                          key: "amount",
                          align: "right",
                          render: (_, record) => (
                            <>
                              ${Number(record.amount || 0).toLocaleString()}{" "}
                              <span className="approve-offer-percentage">
                                ({record?.percentage}%)
                              </span>
                            </>
                          ),
                        },
                      ]}
                      dataSource={paymentDetails?.map((item, index) => ({
                        ...item,
                        key: `${item?.payment}-${item?.date}-${index}`,
                      }))}
                      pagination={false}
                      bordered={false}
                      size="small"
                    />
                  ) : (
                    <span className="approve-offer-detail-value">-</span>
                  )}
                </div>
              </div>
            </div>

            <div className="approve-offer-actions">
              <Button
                className="approve-offer-cancel-button"
                onClick={() => setIsActionModal(false)}
              >
                Cancel
              </Button>

              <Button
                className="approve-offer-confirm-button"
                onClick={() => {
                  setIsActionModal(false);
                  handleCounterOfferStatus(1);
                }}
              >
                Yes, Accept Offer
              </Button>
            </div>
          </div>
        );

      case "BulkCampaign":
        return (
          <div className="bulk-campaign-modal-content">
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <Text className="common-sub-header-black-14">
                Create Instant Campaign
              </Text>
              <Text className="location-grey-text-12">
                Create a new campaign or add the filtered products to an
                existing campaign with a common timeline.
              </Text>
            </div>
            <div
              className="common-text-344054-12"
              style={{
                display: "flex",
                alignItems: "flex-start",
                margin: "20px 0",
                padding: "12px 14px",
                background: "#fff1f2",
                borderRadius: 6,
              }}
            >
              <ExclamationCircleOutlined
                style={{ color: "#d2042d", marginRight: 10, marginTop: 2 }}
              />
              <span>
                The selected products will use the same start date and end date.
              </span>
            </div>
            <Form
              form={bulkCampaignForm}
              layout="vertical"
              onFinish={handleStaticBulkCampaignCreate}
              onValuesChange={(changedValues) => {
                if ("campaign_id" in changedValues) {
                  setBulkSelectedCampaign(changedValues.campaign_id);
                }
                if ("campaign_name" in changedValues) {
                  setBulkNewCampaignName(changedValues.campaign_name || "");
                }
              }}
              className="bulk-campaign-form"
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  gap: 16,
                }}
              >
                <Form.Item
                  name="start_date"
                  label={
                    <span className="common-action-items-text-black-14">
                      Start Date {star}
                    </span>
                  }
                >
                  <DatePicker
                    format="MM/DD/YYYY"
                    placeholder="Select start date"
                    className="bulk-campaign-date-picker"
                    style={{ width: "100%", height: 35 }}
                    open={false}
                    inputReadOnly
                    allowClear={false}
                    disabledDate={(date) => {
                      const endDate =
                        bulkCampaignForm.getFieldValue("end_date");

                      return !!(endDate && date.isAfter(endDate, "day"));
                    }}
                    onChange={(date) => {
                      const endDate =
                        bulkCampaignForm.getFieldValue("end_date");

                      if (date && endDate && endDate.isBefore(date, "day")) {
                        bulkCampaignForm.setFieldValue("end_date", null);
                      }
                    }}
                  />
                </Form.Item>
                <Form.Item
                  name="end_date"
                  label={
                    <span className="common-action-items-text-black-14">
                      End Date {star}
                    </span>
                  }
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const startDate = getFieldValue("start_date");

                        if (
                          !value ||
                          !startDate ||
                          !value.isBefore(startDate, "day")
                        ) {
                          return Promise.resolve();
                        }

                        return Promise.reject(
                          new Error("End Date cannot be before Start Date!"),
                        );
                      },
                    }),
                  ]}
                >
                  <DatePicker
                    format="MM/DD/YYYY"
                    placeholder="Select end date"
                    className="bulk-campaign-date-picker"
                    style={{ width: "100%", height: 35 }}
                    open={false}
                    inputReadOnly
                    allowClear={false}
                    disabledDate={(date) => {
                      const startDate =
                        bulkCampaignForm.getFieldValue("start_date");

                      return !!(startDate && date.isBefore(startDate, "day"));
                    }}
                  />
                </Form.Item>
              </div>
              <Form.Item
                label={
                  <span className="common-action-items-text-black-14">
                    Campaign Type {star}
                  </span>
                }
              >
                <Radio.Group
                  value={bulkCampaignMode}
                  onChange={(event) => {
                    const mode = event.target.value;
                    setBulkCampaignMode(mode);
                    setBulkSelectedCampaign(undefined);
                    setBulkNewCampaignName("");
                    bulkCampaignForm.setFieldsValue({
                      campaign_id: undefined,
                      campaign_name: undefined,
                    });

                    bulkCampaignForm.setFields([
                      { name: "campaign_id", errors: [] },
                      { name: "campaign_name", errors: [] },
                    ]);
                  }}
                  className="bulk-campaign-radio-group"
                >
                  <Radio value="existing">Existing Campaign</Radio>
                  <Radio value="new">Create New Campaign</Radio>
                </Radio.Group>
              </Form.Item>
              {bulkCampaignMode === "existing" ? (
                <Form.Item
                  label={
                    <span className="common-action-items-text-black-14">
                      Select Campaign {star}
                    </span>
                  }
                >
                  <div className="select-campaign-dropdown-div">
                    <Form.Item
                      name="campaign_id"
                      noStyle
                      rules={[
                        {
                          required: true,
                          message: "Please select a campaign!",
                        },
                      ]}
                    >
                      <Select
                        getPopupContainer={(triggerNode) =>
                          triggerNode.closest(".ant-modal") || document.body
                        }
                        dropdownStyle={{
                          zIndex: 3000,
                          pointerEvents: "auto",
                        }}
                        className="select-campaign-dropdown"
                        placeholder="Select the Campaign"
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        bordered={false}
                        showArrow
                        onChange={(value) => {
                          setBulkSelectedCampaign(value);
                        }}
                      >
                        {savedCampaigns?.map((campaign) => (
                          <Select.Option
                            key={campaign?.id}
                            value={campaign?.id}
                            label={`${campaign?.name} (${campaign?.cid})`}
                          >
                            {campaign?.name} ({campaign?.cid})
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                </Form.Item>
              ) : (
                <Form.Item
                  name="campaign_name"
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "Campaign Name is required!",
                    },
                    {
                      max: 100,
                      message: "Campaign Name cannot exceed 100 characters!",
                    },
                  ]}
                >
                  <FloatingInput
                    className="billboard-input-feild"
                    label={<>Campaign Name {star}</>}
                    customStyles={floatingInputStyles}
                  />
                </Form.Item>
              )}

              <Divider style={{ margin: "16px 0" }} />

              <div className="bulk-campaign-modal-actions">
                <Button
                  onClick={handleCloseModal}
                  className="cancel-create-campaign-btn"
                >
                  Cancel
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={isCreateDisabled}
                  className={`create-campaign-bulk-btn ${isCreateDisabled ? "disabled-opacity" : ""}`}
                >
                  Create Campaign
                </Button>
              </div>
            </Form>
          </div>
        );

      default:
        return null;
    }
  };
  return (
    <div>
      <Modal
        open={isActionModal}
        footer={null}
        onCancel={type === "approve" ? undefined : handleCloseModal}
        closable={type !== "approve"}
        centered
        className={`re-usable-modal-terms ${
          type === "approve" ? "approve-action-modal" : ""
        }`}
      >
        {renderModalContent()}
        {isLoading && (
          <div className="loading-css">
            <Spin size="large" fullscreen />
          </div>
        )}
      </Modal>
    </div>
  );
};
export default ReusableModal;
